import React from 'react';

/** Replace the hrefs with your real policy and support links. */
const links = [{
  label: 'Contact / Support',
  href: '#contact'
}, {
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Terms & Conditions',
  href: '#terms'
}, {
  label: 'Refund Policy',
  href: '#refund'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-167" data-mp="3a5stg9tysdwx">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-168" data-mp="3f3ucwvvayf8x">
        <div data-id="element-169" data-mp="3k5bc8my51tne">
          <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-170" data-mp="3k51hkm25eybd">
            PMU Instructor Ready™
          </p>
          <p className="mt-1.5 font-body text-[13px]" data-id="element-171" data-mp="3t2lp2cqltquf">Prof. Kyra · Digital Educational Product</p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-172" data-mp="1tsc4fvmcqce7">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-173" data-mp="5g1xy1hoo76u">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/55" data-id="element-174" data-mp="3nvw2gfktwmyf">
        © 2026 PMU Instructor Ready™ by Prof. Kyra. Digital PDF teaching resources for permanent makeup instructors,
        trainers, and academy owners. Does not replace required qualifications, supervised practical training, or local
        licensing requirements. Secure checkout — payment processed in your local currency.
      </p>
    </footer>;
}